import * as React from 'react';
import { Lightbulb } from '@mui/icons-material';


const GradientLightbulb = () => (
  <>
    <svg width={0} height={0}>
      <defs>
        <linearGradient id="gradient">
          <stop offset="0%" stopColor="#0D9488" />
          <stop offset="100%" stopColor="#14B8A6" />
        </linearGradient>
      </defs>
    </svg>
    <Lightbulb
      sx={{ fill: 'url(#gradient)', marginRight: '0.95rem' }} // Apply the gradient to the path's fill
    />
  </>
);

export default GradientLightbulb;
